export type OrderStatus =
  | "DRAFT"
  | "CONFIRMED"
  | "PREPARING"
  | "READY"
  | "COMPLETED"
  | "CANCELLED";

/** ສະຖານະອໍເດີເປັນພາສາລາວ (ສຳລັບແສງໃນ UI) */
export const ORDER_STATUS_LABELS_LAO: Record<OrderStatus, string> = {
  DRAFT: "ຮ່າງ",
  CONFIRMED: "ຢືນຢັນ",
  PREPARING: "ກຳລັງເຮັດ",
  READY: "ພ້ອມຮັບ",
  COMPLETED: "ສຳເລັດ",
  CANCELLED: "ຍົກເລີກ",
};

export type OrderChannel = "APP" | "WALKIN";
export type OrderPickupType = "ASAP" | "SLOT";

/** Row for Orders dashboard (HQ) list */
export type OrderListRow = {
  id: string;
  orderNo: string;
  channel: OrderChannel;
  branchId: string;
  branchName: string;
  customerId: string | null;
  status: OrderStatus;
  total: number;
  paidTotal: number;
  currency: string;
  pickupType: OrderPickupType;
  pickupAt: string | null;
  createdAt: string;
};

/** Modifier on an order item (for detail view) */
export type OrderDetailItemModifier = {
  name: string;
  priceDelta: number;
  qty: number;
};

/** Order item with product/variant and modifiers (for detail view) */
export type OrderDetailItem = {
  id: string;
  variantId: string;
  productName: string;
  productImageUrl: string | null;
  variantName: string;
  qty: number;
  unitPrice: number;
  lineTotal: number;
  modifiers: OrderDetailItemModifier[];
};

/** Status event row (for timeline) */
export type OrderStatusEventDetail = {
  id: string;
  fromStatus: string;
  toStatus: string;
  at: string;
  byUserDisplayName: string | null;
};

/** Full order detail for Order detail page */
export type OrderDetail = {
  id: string;
  orderNo: string;
  channel: OrderChannel;
  branchId: string;
  branchName: string;
  customerId: string | null;
  customerName: string | null;
  customerPhone: string | null;
  status: OrderStatus;
  subtotal: number;
  discountTotal: number;
  total: number;
  paidTotal: number;
  currency: string;
  pickupType: OrderPickupType;
  pickupAt: string | null;
  createdAt: string;
  updatedAt: string;
  items: OrderDetailItem[];
  statusEvents: OrderStatusEventDetail[];
};
